import { render, staticRenderFns } from "./servicesHome.vue?vue&type=template&id=6d5b10e8&scoped=true"
import script from "./servicesHome.vue?vue&type=script&lang=js"
export * from "./servicesHome.vue?vue&type=script&lang=js"
import style0 from "./servicesHome.vue?vue&type=style&index=0&id=6d5b10e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5b10e8",
  null
  
)

export default component.exports